import clsx from "clsx";
import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { gAuthOffVerify, telegramAuthVerify } from "src/api/securityAuthApi";
import { BASE_PATH } from "src/config/constants";
import useLogout from "src/hooks/useLogout";
import { useAppSelector } from "src/redux/redux-hooks";
import { showErrorToast, showSuccessToast } from "src/utils/toast";

const TelegramAuthOff: React.FC<{ loading: boolean; otpSend: boolean }> = ({ loading, otpSend }) => {
  const { userData } = useAppSelector((state) => state.user);
  const [otp, setOtp] = useState<string>("");
  const [loading2, setLoading2] = useState<boolean>(false);

  const navigate = useNavigate();
  const { handleLogout } = useLogout();

  const onOtpChange = (otp: string) => {
    const nOtp = otp.replace(/\D/g, "");
    setOtp(nOtp);

    if (nOtp.length === 6 && userData?.user_id && userData?.is_telegram_auth) {
      setLoading2(true);
      telegramAuthVerify({ otp_type: "AUTH_DISABLE", payload: { otp: nOtp, admin_id: userData?.user_id } })
        .then(() => {
          showSuccessToast("2-Step Verification is disabled for your account.");
          handleLogout();

          navigate(`${BASE_PATH}/login`);
        })
        .catch(() => {
          const message = "User not remove.";
          showErrorToast(message);
          setOtp("");
        })
        .finally(() => setLoading2(false));
    } else if (nOtp.length === 6 && userData?.user_id && userData?.is_two_factor_authentication) {
      setLoading2(true);
      gAuthOffVerify({ token: nOtp })
        .then(() => {
          showSuccessToast("2-Step Verification is disabled for your account.");
          handleLogout();

          navigate(`${BASE_PATH}/login`);
        })
        .catch(() => {
          const message = "User not remove.";
          showErrorToast(message);
          setOtp("");
        })
        .finally(() => setLoading2(false));
    }
  };

  return (
    <div className="tab-content mt-4">
      <div className={clsx("tab-pane telegram active", { "loader-section-parent": loading || loading2 })}></div>
      {(loading || loading2) && <div className="loader-overlay"></div>}

      {otpSend && (
        <div className="tab-pane active">
          <div className="mt-2 mb-3 login-auth">
            <h3 className="text-center">Security Code Verification</h3>
            <div className="mt-3 text-center">Enter 6-digit code from your security auth verification App</div>
            <form autoComplete="off" method="post" className="mt-3">
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                <OTPInput
                  value={otp}
                  onChange={onOtpChange}
                  numInputs={6}
                  inputType="tel"
                  renderInput={(props) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        min="0"
                        max="9"
                        maxLength={1}
                        pattern="[0-9]"
                        {...props}
                        style={{}}
                        className="otp-input"
                      />
                    </div>
                  )}
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TelegramAuthOff;
